import { ChevronLeft, ChevronRight, LoaderCircle } from "lucide-react";
import { Button } from "@web/components/ui/button";
import type { SourceDiscoverResult, SourceDiscoverSection } from "../api";
import { DiscoverNavItem } from "./source-discover-items";

export function DiscoverCategoryTabs({
  section,
  insideHome,
  currentUrl,
  loading,
  homeDiscover,
  onNavigate,
  onHomeSelect,
}: {
  section: SourceDiscoverSection;
  insideHome: boolean;
  currentUrl?: string;
  loading: boolean;
  homeDiscover?: SourceDiscoverResult;
  onNavigate: (targetUrl: string) => void;
  onHomeSelect: () => void;
}) {
  return (
    <section className="space-y-2">
      <div className="relative pr-20">
        <div className="flex flex-wrap gap-2">
          <button
            type="button"
            disabled={loading || insideHome || !homeDiscover}
            className={`rounded-full border px-3 py-1.5 text-xs transition-colors disabled:cursor-not-allowed disabled:opacity-50 ${
              insideHome ? "bg-foreground text-background" : "bg-background text-muted-foreground hover:bg-accent hover:text-accent-foreground"
            }`}
            onClick={onHomeSelect}
          >
            首页
          </button>
          {section.items.map(item => (
            <DiscoverNavItem
              key={`${section.id}:${item.title}:${item.sourceUrl}`}
              item={item}
              active={!insideHome && Boolean(item.sourceUrl && item.sourceUrl === currentUrl)}
              onNavigate={onNavigate}
            />
          ))}
        </div>
        {loading && (
          <span className="pointer-events-none absolute right-0 top-1/2 flex -translate-y-1/2 items-center gap-1 rounded-full bg-background px-2 py-1 text-xs text-muted-foreground">
            <LoaderCircle className="size-3 animate-spin" />
            加载中
          </span>
        )}
      </div>
    </section>
  );
}

export function DiscoverPagination({
  discover,
  loading,
  onNavigate,
}: {
  discover: SourceDiscoverResult;
  loading: boolean;
  onNavigate: (targetUrl: string) => void;
}) {
  const pagination = discover.pagination;
  if (!pagination?.previousUrl && !pagination?.nextUrl) return null;

  return (
    <div className="flex items-center justify-between gap-3 border-t pt-4">
      <Button type="button" className="flex-1" variant="secondary" disabled={loading || !pagination.previousUrl} onClick={() => pagination.previousUrl && onNavigate(pagination.previousUrl)}>
        <ChevronLeft className="size-4" />
        上一页
      </Button>
      <span className="shrink-0 rounded-full bg-background px-3 py-1 text-xs text-muted-foreground">
        {pagination.currentPage ? `第 ${pagination.currentPage} 页` : "分页"}
        {pagination.totalPages ? ` / ${pagination.totalPages}` : ""}
      </span>
      <Button type="button" className="flex-1" variant="secondary" disabled={loading || !pagination.nextUrl} onClick={() => pagination.nextUrl && onNavigate(pagination.nextUrl)}>
        下一页
        <ChevronRight className="size-4" />
      </Button>
    </div>
  );
}
